//@ts-nocheck
const DEFAULT_LOCALE = 'en';

export const normalizeLocale = (...locales) => {
  const locale = locales.find(
    (candidate) => typeof candidate === 'string' && candidate.trim() !== ''
  );

  return (locale || DEFAULT_LOCALE).trim().replace(/_/g, '-');
};

export const getBrowserLocale = () => {
  const browserLocales = globalThis.navigator?.languages ?? [];

  return normalizeLocale(
    browserLocales.find(
      (locale) => typeof locale === 'string' && locale.trim() !== ''
    ),
    globalThis.navigator?.language
  );
};
